import React, {useContext} from 'react';
import {AuthContext} from '../context';
import {useIntl} from 'react-intl';
import '../AuthWrapper.style.less';
import AppConfirmPopup from '../../../domain/core/AppConfirmPopup';
import {useShopAdminShop} from '../../../shared/hooks/useShopAdminShop';

const Logout = () => {
  const {visibleLogout, setVisibleLogout, logout, loading} =
    useContext(AuthContext);
  const {messages} = useIntl();
  // A shop admin's dialog shows their shop's logo.
  const {logoUrl} = useShopAdminShop();

  return (
    <AppConfirmPopup
      loading={loading}
      visible={visibleLogout}
      setVisible={setVisibleLogout}
      handleOK={logout}
      title={messages['common.logout.title']}
      okText={messages['common.ok']}
      cancelText={messages['common.cancel']}
      logoUrl={logoUrl}
    />
  );
};

export default Logout;
